import styled from "styled-components"
import { Link } from "react-router-dom"

export const Container = styled.div`
    display: flex;
    width: 100%;
    max-width: 800px;
`

export const StyledLink = styled(Link)`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    color: var(--secondary);
    transition: all 0.5s ease;
    
    &:hover{
        color: var(--primary);
        transform: scale(1.1);
    }
`

export const StyledButton = styled.button`
    border: none;
    border-radius: 10px;
    padding: 7px 10px;
    background-color: var(--${props => props.buttonColor});
    color: var(--dark${props => props.buttonColor});
    font-weight: 600;
`